import { superForm } from 'sveltekit-superforms/client';

import { snacks } from '@features/snackbar/store/snacks';

import { purchaseForm, type PurchaseForm } from '../config';

export const getPurchaseFormData = (data: PurchaseForm, onSuccess: () => void) => {
  const { form, errors, enhance, submitting } = superForm<typeof purchaseForm>(data, {
    taintedMessage: false,
    resetForm: true,
    id: 'purchase-form',
    validators: purchaseForm,
    onResult: ({ result }) => {
      if (result.type === 'success') {
        onSuccess();
      }
    },
    onError: ({ result }) => {
      const { status } = result;

      if (status === 500) {
        snacks.push({ type: 'error', message: 'Something went wrong' });
      }
    },
  });

  return {
    form,
    errors,
    submitting,
    enhance,
  };
};
